// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d67528b3","455":"06857dbd"}[chunkId] + ".chunk.js";
};